import React, { useState } from 'react'
import { Card, Form, Input, Button, Row, Col, message } from 'antd'
import { UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { useAuth } from '../../../auth/hooks/useAuth'
import { authService } from '../../../shared/api/services/auth.service'

export const PersonalInfoForm: React.FC = () => {
    const { user, loadUser } = useAuth()
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const handleUpdateProfile = async (values: any) => {
        try {
            setLoading(true)
            await authService.updateProfile({ name: values.name, phone: values.phone })
            await loadUser()
            message.success('Personal information updated successfully!')
        } catch (error: any) {
            const errorMsg = error?.response?.data?.error?.message || 'Failed to update personal information'
            message.error(errorMsg)
        } finally {
            setLoading(false)
        }
    }


    return (
        <Card title="Personal Information">
            <Form
                form={form}
                layout="vertical"
                onFinish={handleUpdateProfile}
                initialValues={{
                    name: user?.name || '',
                    email: user?.email || '',
                    phone: user?.phone || '',
                }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Full Name"
                            name="name"
                            rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                            <Input prefix={<UserOutlined />} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: 'Please enter your email' },
                                { type: 'email', message: 'Please enter a valid email' }
                            ]}
                        >
                            <Input prefix={<MailOutlined />} disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Phone Number"
                            name="phone"
                        >
                            <Input prefix={<PhoneOutlined />} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Save Changes
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

